@if (utility.myDomain != KNOWLEDGE_DOMAIN && !isVideoCall) {
  <div>
    <knowledgeModalPopUp></knowledgeModalPopUp>
    <app-video-call-modal></app-video-call-modal>
    <!--<knowledgeModalPopUp *ngIf="showHideModal"></knowledgeModalPopUp>-->
    <ba-page-top [avatarId]="currentAvatarId" [avatarType]="currentAvatarType"></ba-page-top>
    <left-side-menu></left-side-menu>
    <div class="al-main">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- <project-switcher></project-switcher> -->
  </div>
}

@if (utility.myDomain === KNOWLEDGE_DOMAIN && !isVideoCall) {
  <div>
    <div class="knowledge-home-page-container" [ngClass]="{'knowledge-home-page-container-is-menu' : isMenu}">
      <knowledge-header></knowledge-header>
      @if (isMenu) {
        <div class="left-menu">
          <knowledge-left-side-menu></knowledge-left-side-menu>
        </div>
      }
      <div class="knowledge-inner-container">
        <div class="knowledge-container">
          <router-outlet></router-outlet>
        </div>
        <div class="knowledge-footer">
          <knowledgeFooterComponent></knowledgeFooterComponent>
        </div>
      </div>
    </div>
  </div>
}
@if (isVideoCall) {
  <div>
    <app-video-calls>
    </app-video-calls>
  </div>
}
